import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { Observable } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';

export const convertFormatsResolver: ResolveFn<Observable<ISbStoryData[]>> = () => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  return storyblokService.getStories({ content_type: 'ImageFormat' });
};
